import { getListaStift } from "@/services/report";
import ListaPlataforma, { ColunaLista } from "../ListasPlataformas/ListaPlataforma";

interface ListaStiftItem {
  nomeAluno: string;
  email: string;
  // "<Específica>;<Específica>-Tira Dúvidas;" por específica ativa — padrão de
  // importação da Stift, montado pelo backend.
  contratacaoStift: string;
}

const colunas: ColunaLista<ListaStiftItem>[] = [
  { titulo: "Nome do Aluno", campo: "nomeAluno", width: 260 },
  { titulo: "Email", campo: "email", width: 240 },
  { titulo: "Contratação Stift", campo: "contratacaoStift", width: 520 },
];

export default function ListaStift() {
  return (
    <ListaPlataforma<ListaStiftItem>
      titulo="Lista STIFT"
      nomeArquivo="lista_stift"
      nomePlanilha="Lista STIFT"
      buscar={getListaStift}
      colunas={colunas}
    />
  );
}
